export default __webpack_public_path__ + "static/media/BSTInfo.7ba11aae.md";